// src/pages/ShreeGurupeeth.js
import React, { useContext, useEffect } from "react";
import { BsPinMapFill, BsPhone, BsEnvelope } from "react-icons/bs";
import { Link } from "react-router-dom";
import { FaRegCalendarAlt, FaUniversity, FaGlobe } from "react-icons/fa";
import DonateButton from "../components/Donate";
import Header from "../components/Layout/Header";
import MatruKund from "../assets/Matrutirth_Image.jpg";
import AnnaChatra from "../assets/annachtra.png";
import gurupeethEntrace from "../assets/Gurupith 1.jpg";
import SABHAMANDAP from "../assets/SABHAMANDAP.jpg";
import vatrushamandir from "../assets/vatrushamandir.jpg";
import sevekariNivas from "../assets/Sevekari_Niwas.jpg";
import AyurvedDeptImg from "../assets/Ayurved.jpg";
import MudranImg from "../assets/Mudran.jpg";
import panchKarmImg from "../assets/panchakram hospital.jpg"

import { LanguageContext } from "../context/LanguageContext";
import "./ShreeGurupeeth.css";

const translations = {
  en: {
    header: "Akhil Bharatiya Shree Swami Samarth Gurupeeth",
    aboutTitle: "About Shree Swami Samarth Gurupeeth",
    aboutDesc: `On 1st November 1992, Param Pujya Gurumauli laid the foundation stone of Shree Gurupeeth, taking a step towards realizing Sadguru Param Pujya Moredada's dream of establishing a "Spiritual University".

This initiative received strong support from the selfless dedication of volunteers and monthly contributions through the "One Rupee Daily" campaign, which is humbly offered at the Guru's feet during the monthly satsang (fourth Saturday). With this fund and public participation, along with the labor contribution of thousands of volunteers, brick by brick, after a decade of tireless efforts, the Shree Gurupeeth that stands today has become an inspiring symbol of the volunteers' sweat, discipline, and dedication. Where every contribution has value, every hand has strength, and every day carries a resolve to reach new heights of service.

At Shree Swami Samarth Guru Peeth, the lifelike idol of Shree Swami Samarth Maharaj seated on the peacock throne in the Darbar is the central focus for darshan and meditation.

The Darbar with its vast Sabha Mandap, through its architectural design and yantra installation, promotes spiritual energy. The campus includes memorial sites of Tejonidhi Sadguru P.P. Moredada and Sadguru P.P. Pithale Maharaj, Vatvruksha Temple, Yagna Bhoomi, Prasadalaya, as well as a Veda Study Department with collections of Vedas, Puranas, and rare manuscripts. Scientific training in yagna-worship, rituals, and guidance for simplified yagna procedures for common devotees is provided.

The printing press produces literature, monthly publications, and guidance materials.

The Ayurveda Department operates with plant cultivation, Panchakarma, medicine manufacturing, and research along with a state-of-the-art laboratory.

The Annachatra building has solar-powered cooking, sterilized storage, and meal arrangements for thousands of devotees at once.`,
    stats: [
      "Established on 1st November 1992 at Trimbakeshwar",
      "A living spiritual university envisioned by Sadguru Moredada",
      "Spreading Swami Samarth Maharaj's teachings globally through seva, satsang, and welfare",
    ],
    contactTitle: "Contact Info",
    address:
      "Akhil Bharatiya Shree Swami Samarth Gurupeeth, Trimbakeshwar, Nashik, Maharashtra, India – 422212",
    phone: "+91 2594 234253 / 54",
    email: "info@gurupeeth.in",
    projectsTitle: "Gurupeeth Initiatives",
    projectsDesc:
      "Explore key initiatives developed by Shree Gurupeeth to uplift society and preserve culture.",
    projects: [
      {
        title: "MatruKund — Shree Gurupeeth",
        desc: "Community built sacred water structure",
      },
      {
        title: "Annachatra - Shree Gurupeeth",
        desc: "Free food distribution",
      },
    ],
   divisionsTitle: "Gurupeeth Divisions",
divisions: [
  
  {
    title: "Gurupeeth Entrance",
    desc: "The grand entrance of Gurupeeth symbolizes devotion, discipline, and faith. It inspires every visitor with the essence of Guru tradition.",
    img: gurupeethEntrace,
  },
  {
    title: "Sabha Mandap",
    desc: "A large hall in the main temple area used for spiritual gatherings, meditation, and bhajans. Volunteers from across the country receive regular training here.",
    img: SABHAMANDAP,
  },
  {
    title: "Vatvruksha Temple",
    desc: "A sacred temple built around a holy banyan tree, symbolizing divine grace and spiritual refuge for devotees.",
    img: vatrushamandir,
  },
  {
    title: "Sevekari Nivas",
    desc: "A well-equipped residential facility for volunteers within the Gurupeeth campus, providing a peaceful environment for spiritual practice and selfless service.",
    img: sevekariNivas,
  },
  {
    title: "Ayurveda Department",
    desc: "The Ayurveda department conducts nationwide awareness and research programs involving Panchakarma, medicine production, and prescription studies. It produces high-quality rare Ayurvedic medicines and treats patients from all traditions using authentic Ayurvedic principles.",
    img: AyurvedDeptImg,
  },
  {
    title: "Mudran Department",
    desc: "Through spiritual discourses, meditation, bhajans, initiation ceremonies, and other religious activities, this department guides devotees on the path of self-development. It also houses valuable spiritual literature for seekers from across India.",
    img: MudranImg,
  },
  {
    title: "Panchakarma Hospital",
    desc: "A 50-bed advanced Panchakarma center operated under expert doctors. It helps patients achieve holistic physical and mental health through Yoga, Pranayama, Meditation, and Panchakarma therapies.",
    img: panchKarmImg,
  },
  
],
    home: "Home",
  },
  mr: {
    header: "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ",
    aboutTitle: "श्री स्वामी समर्थ गुरुपीठ बद्दल",
    aboutDesc: `१ नोव्हेंबर १९९२ रोजी परमपूज्य गुरुमाऊली यांनी श्री गुरुपीठाची पायाभरणी करून सद्गुरु परमपूज्य मोरेदादांचे "आध्यात्मिक विद्यापीठ" उभारण्याचे स्वप्न साकार करण्याच्या दिशेने दिशेने एक पाऊल टाकले. 

या उपक्रमाला सेवेकऱ्यांच्या निःस्वार्थ समर्पणाने आणि "दररोज एक रुपया" उपक्रमातून मिळालेल्या मासिक अर्पणांनी दृढ आधार दिला, जो मासिक सत्संग (चौथा शनिवार) निमित्त गुरुचरणी नम्रतेने अर्पण केला जातो. या निधी आणि लोकसहभागाबरोबरच हजारो सेवेकऱ्यांच्या श्रमदानाने विटा विटा रचत दशकभराच्या अथक परिश्रमानंतर उभे राहिलेले श्री गुरुपीठ आज सेवेकऱ्यांच्या घाम, शिस्त आणि समर्पणाचे प्रेरणादायी प्रतीक ठरले आहे. जिथे प्रत्येक योगदानाची किंमत आहे, प्रत्येक हाताची ताकद आहे, आणि प्रत्येक दिवस सेवेच्या नव्या उंचीला नेणारा संकल्प आहे.

श्री स्वामी समर्थ गुरुपीठात, दरबारात मयूरासनावर विराजमान श्री स्वामी समर्थ महाराजांची सजीव भास देणारी मूर्ती दर्शन ध्यानासाठी केंद्रस्थानी आहे. 

विशाल सभा मंडपासह दरबार वास्तुशास्त्रीय रचनेने आणि यंत्रस्थापनेने आध्यात्मिक ऊर्जेला चालना देतो. परिसरात तेजोनिधी सद्गुरू प.पू. मोरेदादा आणि सद्गुरू प.पू. पिठले महाराजांची स्मृतिस्थाने, वटवृक्ष मंदिर, यज्ञभूमी, प्रसादालय, तसेच वेद-अध्ययन विभागात वेद-पुराण व दुर्मिळ ग्रंथसंग्रह उपलब्ध आहे. यज्ञ-उपासना, कर्मकांडांचे शास्त्रोक्त प्रशिक्षण आणि सामान्य सेवेकर्‍यांसाठी सुलभ यज्ञविधींचे मार्गदर्शन दिले जाते. 

मुद्रणालयातून साहित्य-ग्रंथ, मासिक व मार्गदर्शक प्रकाशने तयार होतात. 

आयुर्वेद विभागात वनस्पती लागवड, पंचकर्म, औषधनिर्मिती आणि संशोधनासह अद्ययावत प्रयोगशाळा कार्यरत आहे. 

अन्नछत्र इमारतीत सौरऊर्जेवर स्वयंपाक, निर्जंतुकीकृत साठवण, आणि एकावेळी हजारो भाविकांसाठी भोजन व्यवस्था आहे.`,
    stats: [
      "१ नोव्हेंबर १९९२ रोजी त्र्यंबकेश्वर येथे स्थापना",
      "सद्गुरु मोरेदादांचे स्वप्न – सजीव आध्यात्मिक विद्यापीठ",
      "स्वामी समर्थ महाराजांचे तत्त्वज्ञान सेवा, सत्संग आणि कल्याणातून जगभर पसरवणे",
    ],
    contactTitle: "संपर्क माहिती",
    address:
      "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ, त्र्यंबकेश्वर, नाशिक, महाराष्ट्र, भारत – ४२२२१२",
    phone: "+९१ २५९४ २३४२५३ / ५४",
    email: "info@gurupeeth.in",
    projectsTitle: "प्रकल्प उपक्रम",
    projectsDesc:
      "श्री गुरुपीठातर्फे समाज उन्नती आणि संस्कृती संवर्धनासाठी राबविण्यात आलेले महत्त्वाचे उपक्रम जाणून घ्या.",
    projects: [
      {
        title: "मातृकुंड — श्री गुरुपीठ",
        desc: "समाजाच्या श्रमदानातून उभारलेले पवित्र जलकुंड",
      },
      {
        title: "अन्नछत्र - श्री गुरुपीठ",
        desc: "मोफत भोजन वितरण उपक्रम",
      },
    ],
   divisionsTitle: "श्री गुरुपीठातील विविध विभाग",
divisions: [
  
  {
    title: "श्रीगुरुपीठ प्रवेशद्वार",
    desc: "श्रीगुरुपीठाचे भव्य प्रवेशद्वार हे भक्ती, शिस्त आणि श्रद्धेचे प्रतीक आहे. येथे येणाऱ्या प्रत्येक साधकाला हे प्रवेशद्वार गुरुचरित्राची प्रेरणा देते.",
    img: gurupeethEntrace,
  },
  {
    title: "सभामंडप",
    desc: "मुख्य मंदिराच्या परिसरातील भव्य सभामंडप हा साधना, सत्संग, ध्यान व भजनासाठी वापरला जातो. देशभरातून आलेल्या सेवेकऱ्यांना येथे नियमित प्रशिक्षण दिले जाते.",
    img: SABHAMANDAP,
  },
  {
    title: "वटवृक्ष मंदिर",
    desc: "श्री स्वामी समर्थांच्या प्रत्यक्ष कृपेचे प्रतीक असलेले हे पवित्र मंदिर पवित्र वटवृक्षाभोवती उभारले आहे. हे साधकांसाठी आश्रय, शांती आणि कृपेचे केंद्र आहे.",
    img: vatrushamandir,
  },
  {
    title: "सेवेकरी निवास",
    desc: "श्रीगुरुपीठाच्या परिसरात सेवेकऱ्यांसाठी सुसज्ज निवास व्यवस्था केली आहे. येथे राहणारे सेवेकरी अध्यात्मिक साधनेसाठी तसेच सेवाकार्यासाठी प्रशिक्षित आहेत.",
    img: sevekariNivas,
  },
  {
    title: "आयुर्वेद विभाग",
    desc: "आयुर्वेदाचे जनजागृती कार्य करणाऱ्या देशभरातील विविध संस्थांचा लाभ घेऊन ‘पंचकर्म’, ‘औषधनिर्मिती’, ‘औषधनिर्देशन संशोधन प्रयोगशाळा’ आदींचा समावेश असलेला हा विभाग कार्यरत आहे. या विभागात अनेक दुर्मीळ व उत्कृष्ट औषधांचे अत्यंत गुणवत्तापूर्ण उत्पादन केले जाते. देशभरातील सर्व संप्रदायांच्या रुग्णांना अंतर्गत व बाह्य उपचार करून आयुर्वेदाचे मूळ तत्त्वे शिकविली जातात.",
    img: AyurvedDeptImg,
  },
  {
    title: "मूल्य विभाग",
    desc: "श्री स्वामी समर्थ सेवा मार्गातील सत्संग, ध्यान, भजन, दीक्षाभोजन, दीक्षाधान, दिनदर्शिकेतील आध्यात्मिक लेखन आणि विविध धार्मिक उपक्रमांद्वारे साधकांना आत्मोन्नतीचा मार्ग दाखविला जातो. देशभरातील विविध साधकांच्या साहित्यांचा संग्रह या विभागात उपलब्ध आहे.",
    img: SABHAMANDAP,
  },
  {
    title: "पंचकर्म चिकित्सालय",
    desc: "५० बेडचे अत्याधुनिक व तज्ज्ञ डॉक्टरांच्या मार्गदर्शनाखाली कार्यरत असलेले हे पंचकर्म उपचार केंद्र आहे. रुग्णांना शारीरिक तसेच मानसिक आरोग्य मिळविण्यासाठी योग, प्राणायाम, ध्यान, रुग्णोपचार व पंचकर्म उपचार यांच्या साहाय्याने संपूर्ण आरोग्य साध्य करण्याचे कार्य येथे केले जाते.",
    img: vatrushamandir,
  },
  
],
    home: "मुख्यपृष्ठ",
  },
};

export default function ShreeGurupeeth() {
  const { lang } = useContext(LanguageContext);
  const t = translations[lang];
useEffect(() => {
  const sections = document.querySelectorAll(".fade-in-section");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { 
      threshold: 0.1, // Reduced from 0.2 to 0.1 for better mobile triggering
      rootMargin: "0px 0px -50px 0px" // Trigger slightly before element enters viewport
    }
  );

  sections.forEach((section) => observer.observe(section));
  
  // Fallback for mobile - force visibility after a delay
  const timer = setTimeout(() => {
    sections.forEach(section => {
      if (!section.classList.contains('visible')) {
        section.classList.add('visible');
      }
    });
  }, 1500); // Force show after 1.5 seconds if not triggered

  return () => {
    observer.disconnect();
    clearTimeout(timer);
  };
}, []);

  return (
    <div className="gurupeeth-page">
      <>
        <Header />
        <div className="gurupeeth-header-wrapper">
          <header className="gurupeeth-header">
            <div className="header-center">
              <div className="breadcrumb">
                <Link to="/">{t.home}</Link> &gt; <span>{t.header}</span>
              </div>
              <h1>{t.header}</h1>
            </div>
          </header>
        </div>
      </>

      <main className="gurupeeth-main">
        {/* ABOUT SECTION */}
        <section className="gurupeeth-info fade-in-section">
          <h2>{t.aboutTitle}</h2>
          <div className="gurupeeth-about-text">
            <p>{t.aboutDesc}</p>
          </div>

          <div className="gurupeeth-stats">
            <div className="gurupeeth-stat-card">
              <FaRegCalendarAlt className="gurupeeth-stat-icon" />
              <p>{t.stats[0]}</p>
            </div>
            <div className="gurupeeth-stat-card">
              <FaUniversity className="gurupeeth-stat-icon" />
              <p>{t.stats[1]}</p>
            </div>
            <div className="gurupeeth-stat-card">
              <FaGlobe className="gurupeeth-stat-icon" />
              <p>{t.stats[2]}</p>
            </div>
          </div>

          <h3>{t.contactTitle}</h3>
          <div className="gurupeeth-contact-cards">
            <div className="gurupeeth-contact-card">
              <BsPinMapFill className="icon icon-address" />
              <p>{t.address}</p>
            </div>
            <div className="gurupeeth-contact-card">
              <BsPhone className="icon icon-phone" />
              <p>{t.phone}</p>
            </div>
            <div className="gurupeeth-contact-card">
              <BsEnvelope className="icon icon-email" />
              <p>{t.email}</p>
            </div>
          </div>

          <div className="gurupeeth-buttons">
            <Link to="/donation">
              <DonateButton />
            </Link>
          </div>
        </section>

        {/* DIVISIONS SECTION - MOVED BEFORE PROJECTS */}
        <div className="divider"></div>
        <section id="divisions" className="gurupeeth-divisions fade-in-section">
          <h2 className="section-title">{t.divisionsTitle}</h2>
          <div className="divisions-column-grid">
            {t.divisions.map((item, i) => (
              <div className="division-card-column" key={i}>
                <div className="division-card-inner">
                  <div className="division-image-wrapper">
                    <img src={item.img} alt={item.title} />
                    <div className="division-overlay">
                      <span>{item.title}</span>
                    </div>
                  </div>
                  <div className="division-content">
                    <h4>{item.title}</h4>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* PROJECTS SECTION - MOVED AFTER DIVISIONS */}
        <div className="divider"></div>
        <section id="projects" className="wrap fade-in-section">
          <h2 className="section-title">{t.projectsTitle}</h2>
          <p className="muted-desc">{t.projectsDesc}</p>
          <div className="grid" style={{ marginTop: "12px" }}>
            <Link to="/Matrukund" className="small-card-link">
              <div className="small-card">
                <img src={MatruKund} alt="MatruKund" />
                <h4>{t.projects[0].title}</h4>
                <p className="meta">{t.projects[0].desc}</p>
              </div>
            </Link>
            <Link to="/annachatra" className="small-card-link">
              <div className="small-card">
                <img src={AnnaChatra} alt="Annachatra" />
                <h4>{t.projects[1].title}</h4>
                <p className="meta">{t.projects[1].desc}</p>
              </div>
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}